import IntegrationModel from '@/models/result/IntegrationModel';
import ResultsServiceCollection from '@/collections/ResultsServiceCollection';

/**
 * Integrations collection
 */
export default class IntegrationCollection extends ResultsServiceCollection {

  // Model that is contained in this collection.
  model() {
    return IntegrationModel;
  }

  getModelsFromResponse (response) {
    const models = []
    const { data } = response.getData()

    if (data.pagination) {
      this.set('count', data.pagination.total)
    }

    // Expecting an 'integrations' array in the response
    if (data.integrations) {
      data.integrations.forEach((insert) => {
        const temp = (new (this.model())(insert))
        models.push(temp)
      })
    }

    return models
  }
}
